<div class="flex gap-4 items-center" *transloco="let t">
  <p
    class="font-medium leading-4 text-4 whitespace-nowrap transition-colors"
    [class]="selectedPlanType() === BillingPeriod.Month ? 'text-ink-strong' : 'text-ink-tertiary'"
  >
    {{ t('PAYMENT.MONTHLY') }}
  </p>

  <div
    tabindex="0"
    role="switch"
    (click)="togglePlanType()"
    (keydown.enter)="togglePlanType()"
    (keydown.space)="togglePlanType()"
    [attr.aria-checked]="selectedPlanType() === BillingPeriod.Year"
    class="flex gap-2 items-start relative shrink-0 cursor-pointer"
  >
    <div class="h-5 w-10 rtl:-scale-x-100">
      <div
        class="absolute inset-0 rounded-full transition-colors duration-200"
        [class]="selectedPlanType() === BillingPeriod.Year ? 'bg-primary' : 'bg-stroke-soft'"
      ></div>
      <div
        class="absolute bg-white border border-stroke-strong border-solid rounded-full size-4 top-0.5 transition-all duration-200 shadow-sm"
        [class]="selectedPlanType() === BillingPeriod.Year ? 'left-[1.34375rem]' : 'left-[0.15625rem]'"
      ></div>
    </div>
  </div>

  <div class="flex gap-1 items-center">
    <p
      class="font-medium leading-4 whitespace-nowrap transition-colors"
      [class]="selectedPlanType() === BillingPeriod.Year ? 'text-ink-strong' : 'text-ink-tertiary'"
    >
      {{ t('PAYMENT.YEARLY') }}
    </p>

    @if (yearlyDiscount() > 0) {
    <div class="flex items-center px-1.5 py-0.5 rounded-lg bg-primary">
      <span class="font-semibold text-[0.625rem] text-white whitespace-nowrap leading-none">
        {{ t('SAVE_DISCOUNT') }} {{ yearlyDiscount() | translocoPercent }}
      </span>
    </div>
    }
  </div>
</div>
